<template>
  <div class="container-processos-tabela">
    <div v-if="itens.length <= 0" class="container-processos-no-data">
      <h2>Não foram encontrados registros!</h2>
    </div>
    <v-layout wrap align-center v-else>
      <v-flex xs12 sm12 md12 lg12 d-flex flex-column v-for="processo in itens" :key="processo.id">
        <div class="processo-card" @click="acessar(processo.id)">
          <v-flex class="processo-card-capa" xs12 sm12 md3 lg3 d-flex>
            <span class="processo-card-capa-titulo">Abertura</span>
            <h2 class="processo-card-capa-data">
              {{ processo.dataAbertura | az-date(humanizarFormatoDataPortal(processo.dataAbertura)) }}</h2>
            <span class="processo-card-capa-numero-edital">Nº {{ processo.numeroEdital }}</span>
          </v-flex>

          <v-flex class="processo-card-corpo" xs12 sm12 md3 lg9 d-flex>
            <div class="processo-card-orgao">
              <h2>{{ processo.orgao.nome }}</h2>
            </div>
            <div class="processo-card-item">
              <div class="processo-card-item-container">
                <span class="processo-card-item-label">Objeto</span><br>
                <span class="processo-card-item-label-objeto d-inline-block text-truncate">{{ processo.objeto }}</span>
              </div>
              <div class="processo-card-item-container">
                <span class="processo-card-item-label">Modalidade</span><br>
                <span class="processo-card-item-label-valor">{{ processo.modalidade }}</span>
              </div>
              <div class="processo-card-item-container">
                <span class="processo-card-item-label">Situação</span><br>
                <span class="processo-card-item-label-valor">{{ processo.status | azEnum(statusLicitacao) }}</span>
              </div>
            </div>
          </v-flex>
        </div>
      </v-flex>
    </v-layout>
    <div class="az-pagination">
      <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
      <div class="az-select-pagination">
        <span>Linhas por página:</span>
        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.size"/>
      </div>
    </div>
  </div>
</template>

<script>

import {statusLicitacao} from '@/core/constants'

export default {
  name: 'ListagemProcessosLicitacaoTabela',
  props: ['itens', 'paginacao', 'paginas', 'totalItens'],
  data() {
    return {
      paginacaoInterna: this.paginacao,
      linhasPorPagina: [10, 25, 50, 100],
      statusLicitacao
    }
  },
  watch: {
    paginacaoInterna: {
      handler(novoValor) {
        this.$emit('paginar', novoValor)
      },
      deep: true
    }
  },
  methods: {
    acessar(processoId){
      this.$emit('acessarProcesso', processoId)
    }
  }
}
</script>

<style scoped lang="stylus">

.container-processos-tabela
  padding 10px 10%

.container-processos-no-data
  height 20em
  display flex
  flex-direction column
  justify-content center
  align-items center
  color #A8A8A8

.processo-card
  margin-bottom 15px
  border 1px solid #ced4da
  border-radius 0.25rem
  width 100%
  display flex
  flex-direction row

.processo-card:hover
  cursor pointer
  background-color #F9F9F9

.processo-card-capa
  background-color #58954D
  color #fff
  padding 22px
  display flex
  flex-direction column
  align-items center

.processo-card-capa-titulo
  font-size 14px
  font-weight normal

.processo-card-capa-data
  font-size 18px
  font-weight 600
  margin-bottom 10px

.processo-card-capa-numero-edital
  background-color #F4B310
  padding 10px 25px
  border-radius 50px
  font-weight 400
  text-align center

.processo-card-corpo
  padding 20px
  flex-direction column

.processo-card-item
  display flex
  flex-direction row

.processo-card-item-container
  margin-right 20px

.processo-card-item-label
  font-weight 600
  font-size 16px

.processo-card-item-label-objeto
  max-width 35vw
  min-width 35vw

@media (max-width: 950px)
  .processo-card
    flex-direction column

  .processo-card-item
    flex-direction column

</style>